import { AxiosError } from "axios";
import { useMutation } from "@tanstack/react-query";
import { Log } from "../model/types";
import { AppButton } from "@libs/zapi-ui/custom";
import $api from "@/zapi-admin/shared/api/axios";

export function LogsRow({ log, onResolved }: { log: Log; onResolved?: () => void }) {
  const { isPending, mutate } = useMutation({
    mutationKey: ["resolve-zapi-log"],
    mutationFn: async () => {
      const response = await $api.post(`/projects/chapters/criteria-answer/change-log/${log.id}/resolve`);
      return response.data;
    },
    onSuccess: () => {
      onResolved?.();
    },
    onError: (e) => {
      const msg = (e as AxiosError<{ message: string }>).response?.data?.message || "Error updating log";
      alert(msg);
    }
  });

  return (
    <tr>
      <td className="border border-gray-300 px-2 py-1">{new Date(log.createdAt).toLocaleString()}</td>
      <td className="border border-gray-300 px-2 py-1">{`${log.user.firstName} ${log.user.lastName}`}</td>
      <td className="border border-gray-300 px-2 py-1">{log.criterion?.name}</td>
      <td className="border border-gray-300 px-2 py-1">{log.aiAnswer}</td>
      <td className="border border-gray-300 px-2 py-1">{log.userAnswer}</td>
      <td className="border border-gray-300 px-2 py-1">{log.currentMemoContent.slice(0, 450)}...</td>
      <td className="border border-gray-300 px-2 py-1 text-center">
        {log.state}
        {log.state === "unresolved" && (
          <AppButton appearance="outlined" size="sm" onClick={() => mutate()} disabled={isPending} className="ml-2">
            {isPending ? "Resolving..." : "Resolve"}
          </AppButton>
        )}
      </td>
      <td className="border border-gray-300 px-2 py-1">
        <AppButton
          appearance="text"
          size="sm"
          onClick={() => {
            const blob = new Blob([log.currentMemoContent], { type: "text/markdown" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `memo_${log.id}.md`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          }}
        >
          Download memo
        </AppButton>
      </td>
    </tr>
  );
}
